// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"2c362301","606":"cbaa432e","787":"497ee0e5"}[chunkId] + ".chunk.js";
};